import { useParams } from 'react-router-dom';
import { HISTORY_RECORD_ID_BASE } from '../../api/assets';
import ProcessDetail from './ProcessDetail';
import ProcessHistoryDetail from './ProcessHistoryDetail';

// /assets/process-records/:id 按号段分派 (2026-10-20): 历史加工数据并入材料加工后, id ≥ 9e12 的是
// 历史行 —— 没有识别归因 / 参数采纳 / 效果复核, 详情沿用历史页的版式 (元素表、耗材还原对比).
export default function ProcessRecordEntry() {
    const { id } = useParams<{ id: string }>();
    const n = Number(id);
    if (Number.isFinite(n) && n >= HISTORY_RECORD_ID_BASE) return <ProcessHistoryDetail recordId={n} />;
    return <ProcessDetail />;
}
